module.exports = __webpack_public_path__ + "img/benben tsukumo_sc2.ae683a61.png";